/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Premium_Step_PlanInputs */

const en_premium_step_plan = /** @type {(inputs: Premium_Step_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan and payment`)
};

const es_premium_step_plan = /** @type {(inputs: Premium_Step_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan y pago`)
};

/**
* | output |
* | --- |
* | "Plan and payment" |
*
* @param {Premium_Step_PlanInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const premium_step_plan = /** @type {((inputs?: Premium_Step_PlanInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Premium_Step_PlanInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_premium_step_plan(inputs)
	return en_premium_step_plan(inputs)
});